export default __webpack_public_path__ + "static/media/sony-75class-tv.fd10bc27.jpg";